import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBaseUnitMeasure } from "src/models/Products/BaseUnitMeasure.models";

interface BaseUnitMeasureState {
  baseUnitMeasures: IBaseUnitMeasure[];
  baseUnitMeasureToEdit: IBaseUnitMeasure | null;
}

const initialState: BaseUnitMeasureState = {
  baseUnitMeasures: [],
  baseUnitMeasureToEdit: null,
};

const BaseUnitMeasureSlice = createSlice({
  name: "BaseUnitMeasure",
  initialState,
  reducers: {
    setBaseUnitMeasureList: (
      state,
      action: PayloadAction<IBaseUnitMeasure[]>
    ) => {
      state.baseUnitMeasures = action.payload;
    },
    concatListBaseUnitMeasure: (
      state: BaseUnitMeasureState,
      action: PayloadAction<IBaseUnitMeasure[]>
    ) => {
      state.baseUnitMeasures = [
        ...state.baseUnitMeasures.concat(action.payload),
      ];
    },
    setBaseUnitMeasureToEdit: (
      state,
      action: PayloadAction<IBaseUnitMeasure | null>
    ) => {
      state.baseUnitMeasureToEdit = action.payload;
    },
    addBaseUnitMeasure: (state, action: PayloadAction<IBaseUnitMeasure>) => {
      state.baseUnitMeasures.push(action.payload);
    },
    updateBaseUnitMeasure: (state, action: PayloadAction<IBaseUnitMeasure>) => {
      let itemIndex = state.baseUnitMeasures.findIndex(
        item => item.baseUnitMeasureId === action.payload.baseUnitMeasureId
      );
      if (itemIndex !== -1) state.baseUnitMeasures[itemIndex] = action.payload;
    },
    deleteBaseUnitMeasure: (state, action: PayloadAction<number>) => {
      const newArray = state.baseUnitMeasures.filter(
        item => item.baseUnitMeasureId !== action.payload
      );
      state.baseUnitMeasures = newArray;
    },
  },
});

export const {
  setBaseUnitMeasureList,
  concatListBaseUnitMeasure,
  setBaseUnitMeasureToEdit,
  addBaseUnitMeasure,
  updateBaseUnitMeasure,
  deleteBaseUnitMeasure,
} = BaseUnitMeasureSlice.actions;

export default BaseUnitMeasureSlice.reducer;
